export default "__VITE_ASSET__z69AIXKU__"